import { combineReducers, Reducer } from 'redux';
import { History } from 'history';
import { reducer as formReducer } from 'redux-form';
import { connectRouter } from 'connected-react-router';
import { persistReducer } from 'redux-persist';

import { RootActions } from 'app/redux/action/root-actions';
import { RootState } from 'app/redux/state/root-state';
import { authReducer } from 'app/page/auth/redux/auth-reducer';
import { ordersPersistConfig } from 'app/redux/store/store-config';
import { ordersReducer } from 'app/page/orders/redux/orders-reducer';

const appReducer = (history: History): Reducer<RootState, RootActions> =>
    combineReducers<RootState>({
        router: connectRouter(history),
        form: formReducer,
        auth: authReducer,
        orders: persistReducer(ordersPersistConfig, ordersReducer),
    });

const rootReducer = (history: History): Reducer<RootState, RootActions> => appReducer(history);

export { rootReducer };
